import * as React from "react";
import { markOrderAsHighDefinitionDigitalLocatedMutation } from "../../../graph";
import { playAudioForSuccess } from "../../../helpers/playAudioForSuccess";
import { recordOrderProductionJobScreenLocationMutation } from "../../../graph";
import { resetOrderVendorAssignmentForInHouseShippingMutation } from "../../../graph";
import { useMutation } from "@apollo/client";
import { useRouter } from "found";
import { useState } from "react";
import BarcodeScanner from "react-barcode-reader";
import PendingStatusView from "../../../components/PendingStatusView";
import TabbedAppBar from "../../../components/TabbedAppBar";
import Typography from "@mui/material/Typography";
import withSnackbar from "../../../components/withSnackbar";

const BulkFilmLocationSetter = ({
  appBarBackgroundColor,
  backUrl,
  showErrorSnackbar,
  showSuccessSnackbar
}) => {
  const { router, match } = useRouter();

  // States:
  const [isLoading, setIsLoading] = useState(false);
  const [currentLocation, setCurrentLocation] = useState(null);

  // Mutations:
  const [recordOrderProductionJobScreenLocation] = useMutation(
    recordOrderProductionJobScreenLocationMutation
  );
  const [markOrderAsHighDefinitionDigitalLocated] = useMutation(
    markOrderAsHighDefinitionDigitalLocatedMutation
  );
  const [resetOrderVendorAssignmentForInHouseShipping] = useMutation(
    resetOrderVendorAssignmentForInHouseShippingMutation
  );

  // Handlers:
  const handleAppHeaderRequestBack = () => router.push(backUrl || "/apps");

  const handleBarcodeError = () => {
    showErrorSnackbar("Error scanning barcode");
    setIsLoading(false);
  };

  const handleBarcodeScan = barcode => {
    try {
      const data = JSON.parse(barcode);
      const { variant, type, id, name } = data;
      if (variant === "LOCATION" && type.toLowerCase() === "screen" && name) {
        setCurrentLocation(name);
      } else if (variant === "OBJECT" && type === "OrderProductionJob" && id) {
        recordOrderProductionJobScreenLocation({
          variables: { location: currentLocation, orderProductionJobId: id }
        })
          .then(
            ({
              data: {
                recordOrderProductionJobScreenLocation: {
                  errors,
                  succeeded,
                  updatedOrderProductionJob
                }
              }
            }) => {
              if (succeeded) {
                const orderId = updatedOrderProductionJob.order.id;
                const highDefinitionDigitalStatus =
                  updatedOrderProductionJob.order.highDefinitionDigitalStatus;

                if (
                  !match.location.pathname.toLowerCase().includes("mach6") &&
                  updatedOrderProductionJob?.order?.vendor?.organization
                    ?.name === "M6 Print and Ship to Philly"
                ) {
                  resetOrderVendorAssignmentForInHouseShipping({
                    variables: { orderId }
                  });
                }
                if (highDefinitionDigitalStatus !== "LOCATED") {
                  markOrderAsHighDefinitionDigitalLocated({
                    variables: { orderId }
                  })
                    .then(
                      ({
                        data: {
                          markOrderAsHighDefinitionDigitalLocated: {
                            succeeded,
                            errors
                          }
                        }
                      }) => {
                        if (succeeded) {
                          showSuccessSnackbar(
                            "Order production job box location has been recorded."
                          );
                          playAudioForSuccess();
                        } else {
                          showErrorSnackbar(errors.orderId.join(", "));
                        }
                      }
                    )
                    .catch(e => showErrorSnackbar(e.message));
                } else {
                  showSuccessSnackbar(
                    "Order production job box location has been recorded."
                  );
                }
              } else {
                showErrorSnackbar(errors.orderProductionJobId.join(", "));
              }
            }
          )
          .catch(e => {
            showErrorSnackbar(e.message);
          });
      }
    } catch {
      setIsLoading(false);
      showErrorSnackbar("Error Scanning Barcode");
    }
  };

  return (
    <div>
      <TabbedAppBar
        title="Bulk Film Location Setter"
        onRequestBack={handleAppHeaderRequestBack}
        appBarBackgroundColor={appBarBackgroundColor}
      />
      {isLoading ? (
        <PendingStatusView status="Loading" />
      ) : (
        <div>
          <BarcodeScanner
            onError={handleBarcodeError}
            onScan={handleBarcodeScan}
          />
          {currentLocation ? (
            <Typography
              variant="h6"
              align="center"
              color="inherit"
              style={{ flexGrow: 1, marginTop: "10em" }}
            >
              Current Location: {currentLocation}
              <br />
              Scan Film or new location
            </Typography>
          ) : (
            <Typography
              variant="h6"
              align="center"
              color="inherit"
              style={{ flexGrow: 1, marginTop: "10em" }}
            >
              Scan Location
            </Typography>
          )}
        </div>
      )}
    </div>
  );
};

export default withSnackbar(BulkFilmLocationSetter);
